var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcResta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7093 33.7286L27.0612 24.3767L3.86309 1.21164C1.38908 3.69526 0 7.05801 0 10.5636C0 14.0692 1.38908 17.4319 3.86309 19.9155L17.7093 33.7286ZM40.1143 27.7474C45.1703 30.0936 52.2751 28.4413 57.5294 23.187C63.8411 16.8753 65.0638 7.82079 60.2061 2.96307C55.3814 -1.86161 46.3269 -0.671963 39.9821 5.63977C34.7278 10.894 33.0755 17.9989 35.4218 23.0549L3.16913 55.3075L7.82858 59.967L30.5971 37.2645L53.3325 60L57.992 55.3405L35.2565 32.6051L40.1143 27.7474Z",
    fill: "#2E3192"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResta);
export default __webpack_public_path__ + "static/media/ic_resta.212829072a9366612f6eabb41948d11d.svg";
export { ForwardRef as ReactComponent };